<div *transloco="let t; read: 'side-content'">
  <accredible-read-more
    [title]="t('title')"
    [ariaLabel]="t('aria_featured_read')"
    [subtitle]="t('featured_read')"
    [urlLabel]="t('see_the_list')"
    [url]="'https://www.indeed.com/career-advice/career-development/certifications-in-demand'" />

  <cf-featured-video />

  <cf-blog-article />
</div>
